module.exports = __webpack_public_path__ + "assets/img/cusQrcode.782803df.png";